import React, { memo } from "react";
import { useInView, IntersectionOptions } from "react-intersection-observer";

interface IProps extends IntersectionOptions {
    children: React.ReactNode;
    className?: string;
}

export function LazyLoad({
    children,
    root,
    threshold = 0,
    rootMargin = "10px",
    triggerOnce = true,
    className = "",
}: IProps) {
    const [ref, inView] = useInView({
        root,
        threshold,
        rootMargin,
        triggerOnce,
    });

    return (
        <div ref={ref} className={className}>
            {inView && children}
        </div>
    );
}

export default memo(LazyLoad);
